import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "disease-item shadow-sm mb-3" }
const _hoisted_2 = { class: "header mb-2" }
const _hoisted_3 = { class: "left" }
const _hoisted_4 = { class: "right" }
const _hoisted_5 = { class: "title mb-1" }
const _hoisted_6 = { class: "description mb-2" }
const _hoisted_7 = {
  key: 0,
  class: "image"
}
const _hoisted_8 = {
  key: 1,
  class: "image d-flex flex-wrap"
}
const _hoisted_9 = { class: "footer mt-2" }
const _hoisted_10 = { class: "right" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Đang diễn ra")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Đã đóng")
const _hoisted_13 = { class: "left" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-comment-dots mr-2" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, "Bình luận", -1)
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Avatar3 = _resolveComponent("Avatar3")!
  const _component_Tag3 = _resolveComponent("Tag3")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Avatar3, {
          round: true,
          avatar: _ctx.diseaseSituation?.reporterAvatar
        }, null, 8, ["avatar"]),
        _createTextVNode(" " + _toDisplayString(_ctx.diseaseSituation?.reporterName || "Người quản lý"), 1)
      ]),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.format(new Date(_ctx.diseaseSituation?.createdAt), "dd/MM/yyyy")), 1)
    ]),
    _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.diseaseSituation?.title), 1),
    _createElementVNode("div", _hoisted_6, [
      _createTextVNode(_toDisplayString(_ctx.fromatString(_ctx.diseaseSituation?.description, 100)) + " ", 1),
      (_ctx.readMore)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showMore && _ctx.showMore(...args)))
          }, "xem thêm"))
        : _createCommentVNode("", true)
    ]),
    (_ctx.diseaseSituation?.listImages?.[0])
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(_component_Avatar3, {
            width: "100%",
            height: "200px",
            radius: "5px",
            avatar: _ctx.diseaseSituation?.listImages?.[0],
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleViewFull(_ctx.diseaseSituation?.listImages?.[0])))
          }, null, 8, ["avatar"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.diseaseSituation?.listImages?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.diseaseSituation?.listImages.slice(
          1,
          _ctx.diseaseSituation?.listImages.length
        ), (item, index) => {
            return (_openBlock(), _createBlock(_component_Avatar3, {
              key: index,
              width: "90px",
              height: "90px",
              radius: "5px",
              avatar: item,
              onClick: ($event: any) => (_ctx.handleViewFull(item))
            }, null, 8, ["avatar", "onClick"]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", null, [
          (_ctx.diseaseSituation?.status == 'OPENING')
            ? (_openBlock(), _createBlock(_component_Tag3, {
                key: 0,
                size: "mini",
                effect: "dark",
                type: "success"
              }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.diseaseSituation?.status == 'RESOLVED')
            ? (_openBlock(), _createBlock(_component_Tag3, {
                key: 1,
                size: "mini",
                effect: "dark",
                type: "warning"
              }, {
                default: _withCtx(() => [
                  _hoisted_12
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.diseaseSituation?.disease?.name)
            ? (_openBlock(), _createBlock(_component_Tag3, {
                key: 2,
                size: "mini",
                effect: "dark",
                type: "danger",
                class: "ml-1"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.diseaseSituation?.disease?.name), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("span", null, _toDisplayString(_ctx.diseaseSituation?.commentCount) + " Bình luận", 1)
      ])
    ]),
    (_ctx.diseaseSituation?.commentCount)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.detailComment(_ctx.diseaseSituation?.id))),
          class: "disease-item__comment"
        }, _hoisted_16))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default")
  ]))
}